import {inject, Injectable} from '@angular/core';
import {API_MAP} from 'app/core/helpers/api.map';
import {Result} from 'app/core/models/result';
import {BaseDataService} from 'app/core/services/base-data.service';
import {Observable, tap, forkJoin, map} from 'rxjs';
import {
  ElasticGlobalSearchResponse,
  GlobalSearchFilterProperties,
  GlobalSearchParams, 
  SearchResultProperties, SearchResults
} from '../models/search-result.model';
import {DataService} from '../../../shared/services/data.service';
import {ElasticsearchService} from '../../../core/services/elasticsearch.service';
import {environment} from '../../../../environments/environment';
import { LanguageService } from 'app/shared/services/language.service';

@Injectable({providedIn: 'root'})
export class SearchResultService extends BaseDataService<SearchResultProperties> {
  override controller = API_MAP.globalSearchPage;
  protected dataService = inject(DataService);
  private readonly currentLanguage = inject(LanguageService).currentLanguage;
  private readonly elasticSearchService = inject(ElasticsearchService);
  
  private readonly MAX_SEARCH_RESULTS = 100;


  override get(controller?: string): Observable<Result<SearchResultProperties>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }

  getSearchFilters(pageTypesContainerPath: string): Observable<Result<GlobalSearchFilterProperties>> {
    return this.dataService.get<Result<GlobalSearchFilterProperties>>(API_MAP.globalSearchFilters(pageTypesContainerPath));
  }

  searchGlobal(params: GlobalSearchParams, fields: string[]): Observable<SearchResults> {    
    const query = this.elasticSearchService.initQuery(true)
    .searchAllFieldsByPartialTerm(params.term, fields)
    .searchAllFieldsByValues(params.pageTypes, fields);
    
    if (params.hospital) {
      query.filterByField('hospital', params.hospital);
    }
    
    query.addPagination(params.skip, params.take);

  // Pass [] to search across all indexes
  return query.executeSearch<ElasticGlobalSearchResponse>([],false, undefined, undefined, this.MAX_SEARCH_RESULTS).pipe(
    map(result => {
      return {
        total: result.total,
        values: result.values
      } as SearchResults;
    })
  );

    // const indexes = this.elasticSearchService.getGlobalSearchIndexes();

    // const searchObservables = indexes.map(index => {
    //   const query = this.elasticSearchService.initQuery()
    //     .searchAllFieldsByPartialTerm(params.term)
    //     .searchAllFieldsByValues(params.pageTypes);
      
    //   query.addPagination(params.skip, params.take);
      
    //   return query.executeSearch<ElasticGlobalSearchResponse>([index]);
    // });

    // return forkJoin(searchObservables).pipe(
    //   map(results => {
    //     const combinedValues: ElasticGlobalSearchResponse[] = [];
    //     let combinedTotal = 0;

    //     results.forEach(result => {
    //       combinedValues.push(...result.values);
    //       combinedTotal += result.total;
    //     });

    //     return {
    //       total: combinedTotal,
    //       values: combinedValues
    //     } as SearchResults;
    //   })
    // );
  }
}
